import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { buildShippingSummary } from './shippingSummary';

export default function ShippingSummaryButton({ rows, formatValue, disabled }) {
  const [copyStatus, setCopyStatus] = useState(null);
  const [copying, setCopying] = useState(false);
  const copy = async () => {
    setCopying(true);
    setCopyStatus(null);
    try {
      const summary = buildShippingSummary(rows, formatValue);
      if (navigator.clipboard?.write && window.ClipboardItem) {
        await navigator.clipboard.write([new window.ClipboardItem({
          'text/html': new Blob([summary.html], { type: 'text/html' }),
          'text/plain': new Blob([summary.plainText], { type: 'text/plain' }),
        })]);
        setCopyStatus({ message: 'Summary copied. Paste it into your email body.' });
      } else {
        await navigator.clipboard.writeText(summary.plainText);
        setCopyStatus({ message: 'Summary copied as plain text. This browser does not support copying the formatted table.' });
      }
    } catch {
      setCopyStatus({ failed: true, message: 'Could not copy the summary. Allow clipboard access in your browser and try again.' });
    } finally {
      setCopying(false);
    }
  };
  return <div className="d-flex flex-column align-items-start gap-1">
    <Button variant="primary" onClick={copy} disabled={disabled || copying || !rows.length}>{copying ? 'Copying...' : 'End of Shift Summary'}</Button>
    {copyStatus && <small role={copyStatus.failed ? 'alert' : 'status'} className={copyStatus.failed ? 'text-danger' : 'text-muted'}>{copyStatus.message}</small>}
  </div>;
}
